import Error404Icon from '@/icons/error_404.svg'

export default function NotFoundPage() {
  return (
    <div className="container mt-20 mb-24 page_errors">
      <div className="flex justify-center">
        <img src={Error404Icon} alt="Error 404" />
      </div>
      <div className="text-center mx-auto w-9/12 md:w-full">
        <h1 className="mb-5 text-gray-900 text-xl md:text-3xl text-center font-bold">
          Lo sentimos. La página que buscas no existe.
        </h1>
        <p className="md:leading-6 text-gray-900 md:text-xl text-base">
          Puede que hayas escrito mal la dirección, que la hayan cambiado o eliminado.
        </p>
      </div>
    </div>
  )
}